import { useTranslation } from "react-i18next";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Typography, Button, Container } from "@mui/material";
import { useAuth } from "./AuthContext";

function Homepage() {
  const { currentUser } = useAuth();
  const { t } = useTranslation();

  return (
    <>
      <Container maxWidth="md">
        <Box
          sx={{
            my: 4,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            minHeight: "70vh",
          }}
        >
          <img
            src="/assets/images/kbquick_logo.svg" // <-- PASTE YOUR LOGO URL HERE
            alt="KB Quick Logo"
            style={{ height: "120px", marginBottom: "40px" }}
          />
          <Typography variant="h2" component="h1" gutterBottom>
            {t("home.welcome")}
          </Typography>
          <Typography variant="h5" color="text.secondary" paragraph>
            {t("home.description")}
          </Typography>
          {!currentUser && (
            <Button
              variant="contained"
              size="large"
              component={RouterLink}
              to="/login"
              sx={{ mt: 4 }}
            >
              {t("home.getStarted")}
            </Button>
          )}
        </Box>
      </Container>
    </>
  );
}

export default Homepage;
